import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileSizeModule } from '@portal-core/general/pipes/file-size/file-size.module';
import { TaskAssetComponent } from './task-asset.component';

@NgModule({
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
    FileSizeModule
  ],
  declarations: [
    TaskAssetComponent
  ],
  exports: [
    TaskAssetComponent
  ]
})
export class TaskAssetModule { }
